var App = App || {};

App.Animations = (function ($) {

    'use strict';

    function ScrollAnimate() {
        $(".widget.widget-skinny-band").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".skinny-band", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-visual-promo-band .visual-promo-band").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".media-content", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-subpromos-band .subpromos-band").ZagScrollAnimate({
            offset: 60,
            targets: [{ selector: ".desktop-wrapper .subpromo-card", type: "animate__fadeIn", stagger: 250 }],
            overflow: false
        });

        $(".widget.widget-subpromos-band .subpromos-band").ZagScrollAnimate({
            offset: 60,
            targets: [{ selector: ".mobile-wrapper .subpromo-card", type: "animate__fadeIn", stagger: 250 }],
            overflow: false
        });

        $(".widget.widget-subpromos-band .subpromos-band").ZagScrollAnimate({
            offset: 60,
            targets: [{ selector: ".static-cards .subpromo-card", type: "animate__fadeIn", stagger: 250 }],
            overflow: false
        });

        $(".widget.widget-icon-band .icon-band").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".intro-content", type: "animate__fadeInLeft", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-card-gallery .card-gallery").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".gallery-cards", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-rates-band .container").ZagScrollAnimate({
            offset: 60,
            targets: [{ selector: ".card-wrapper", type: "animate__fadeIn", stagger: 200 }],
            overflow: false
        });

        $(".widget.widget-rates-band .card-carousel-mobile").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".card-wrapper", type: "animate__fadeIn", stagger: 200 }],
            overflow: false
        });

        $(".widget.widget-category .widget-category-list").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".widget-category-list-item", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-blog-main-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".featured-card", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-blog-list .blog-post-list").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".blogpost-card-wrapper", type: "animate__fadeInUp", stagger: 175 }],
            overflow: false
        });

        $(".widget.widget-blog-post-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".masthead-card", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-related-blog-posts .related-lists").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".blogpost-card-wrapper", type: "animate__fadeInUp", stagger: 175 }],
            overflow: false
        });

        $(".widget.widget-form").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".widget-form-form", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-masthead-detail .masthead-cards").ZagScrollAnimate({
            offset: 90,
            targets: [{ selector: ".masthead-card-wrapper", type: "animate__fadeInDown", stagger: 85 }],
            overflow: false
        });

        $(".widget.widget-masthead-detail .desktop-img-wrapper").ZagScrollAnimate({
            offset: 90,
            targets: [{ selector: ".detail-masthead-img-animate", type: "animate__fadeInRight", stagger: 550 }],
            overflow: true
        });

        $(".widget.widget-masthead-detail .mobile-img-wrapper").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".detail-masthead-img-animate", type: "animate__fadeInDown", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-category-masthead .content-wrapper").ZagScrollAnimate({
            offset: 100,
            targets: [{ selector: ".rich-text, .ctas", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-callout-band").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".callout-band", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-category").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".widget-category-compare-table", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });
    }

    return {
        ScrollAnimate: ScrollAnimate
    };

})(jQuery);

$(function () {
    App.Animations.ScrollAnimate();
});